import React from 'react';
import profile from '../images/profile.png';

function ScientificCommittee({ members, renderExpandableText }) {
  if (!members || members.length === 0) return null;

  return (
    <div className="common-committee-section scientific-list" style={{ marginBottom: '6vw' }}>
      <h2>COMITE SCIENTIFIQUE DU CONGRES</h2>
      <div className="committee-grid">
        {members.map((member) => (
          <div key={member.id} className="committee-member" data-member-id={member.id}>
            <div className="member-photo">
              {member.logo && (
                <div className="company-logo" >
                  <img
                    src={member.logo}
                    alt="Logo"
                    style={{ width: '100%', height: '100%', objectFit: 'contain', maxWidth: '100%', maxHeight: '100%' }}
                    onError={e => e.target.style.display = "none"}
                  />
                </div>
              )}
              <img src={member.image || profile} alt={member.name} />
            </div>
            <div className="member-info">
              <h4 style={{ margin: 0, textAlign: 'center' }}>{member.name}</h4>
              <p>{renderExpandableText(member.title, member.id + '-title')}</p>
              <p>{renderExpandableText(member.organization, member.id + '-org')}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ScientificCommittee;
